export default __webpack_public_path__ + "static/media/elogo.fea1bfb5.png";